import angular from 'angular';
import internalSystemOptionsDirective from './infrastructure-options.directive';
import infrastructureOption from './infrastructureOption';


export default angular.module('app.components.advisory.enterpriseModeling.infrastructureOptions', [
  infrastructureOption
])
  .directive('emInfrastructureOptions', internalSystemOptionsDirective)
  .controller('InfrastructureOptionsController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.enterpriseModeling.infrastructureOptions created');
